<template>
    <div class="container-fluid mt-1 mb-1" style="width: 100%;">
        <video ref="videoPlayer" class="video-js" style="width:100%; height: auto;" controls></video>
    </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
    name: 'VideoPlayer',
    props: [
    'courseid',
    // URL directa del video (p. ej. el de un módulo); si no viene, se pide la del curso
    'src',
    // {
    //     options: {
    //         type: Object,
    //         default() {
    //             return {};
    //         }
    //     }
    // }
],
    data() {
        return {
            player: null,
            path: '',
            course_id: null,
        }
    },
    created(){
        this.course_id = this.courseid

    },
    mounted() {
        // console.log(this.course_id)
        if (this.src) {
            this.loadPlayer(this.src)
        } else {
            this.getURL()
        }

    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    },
    methods: {
        loadPlayer(path) {

            this.player = videojs(this.$refs.videoPlayer, {
                ...this.options,
                fluid: true,
            }, () => {
                // this.player.log('onPlayerReady', this);

                const videoPath = path;

                this.player.src({
                    type: 'video/mp4',
                    src: videoPath
                });

                // Evento que se dispara cuando el video está listo para ser reproducido
                this.player.on('canplay', () => {
                    // Pausar el video después de que está listo
                    this.player.pause();
                });
            });
        },
        getURL() {
            axios.get(`/video/${this.courseid}`)
                .then(response => {
                    this.path = response.data.data;
                    this.loadPlayer(this.path)
                })
                .catch(error => {
                console.error(error);
                });
            },
    }
}
</script>
